const theme = {
  typography: {
    fontFamily: "Cabin"
  }
}

export default theme
